module.exports = __webpack_public_path__ + "static/img/1.9722747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/4/1.png
// module id = vDg5
// module chunks = 0